// Hero headline text carousel
document.addEventListener("DOMContentLoaded", () => {
  const track = document.querySelector(".hero-carousel-track")
  if (!track) return

  const items = track.children
  const count = items.length
  let current = 0

  setInterval(() => {
    current = (current + 1) % count
    track.style.transform = `translateY(-${current * (100 / count)}%)`
  }, 2500)
})
